// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import {
  convertDDtoDMSPref,
  convertDMStoDMSPref,
} from 'helpers/coordsConversion/index'

// e is the event object which has been fired on the given field
// applyChange will take the formatted value or the original
// value if we were not able to interpret it as a coordinate format.

/**
 * tries to format the value provided into DMS. If it fails, <br />
 * it applies the original value without any formatting
 * @param {String} value - value as given to the input field
 * @param {String} axis - latitude || longitude
 * @param {function} applyChange - propagates the formatted value to the change event
 */
const handleCoordinateFieldFormatting = (value, axis, applyChange) => {
  const preferWesternHemisphere = true

  const formatted = (
    // check to see if this is DD value
    convertDDtoDMSPref(value, axis, preferWesternHemisphere) ||
    // if not check to see if it's a DMS value
    convertDMStoDMSPref(value, axis, preferWesternHemisphere)
  )
  // finally, apply either the formatted value or
  // the original one if formatting failed.
  applyChange(formatted || value)
}

export default handleCoordinateFieldFormatting
